<template>
  <div>
    <p class="download-success-view__content-text">
      {{ $t('appleDownloadView.subtitle') }}
    </p>
    <img
      class="download-success-view__background download-success-view__background--left"
      :src="require('images/fs-left-bg.svg')"
      alt="left background"
    >
    <img
      class="download-success-view__background download-success-view__background--right"
      :src="require('images/fs-right-bg.svg')"
      alt="left background"
    >
    <div class="download-success-view__architecture-selection">
      <button
        class="download-success-view__architecture-card"
      >
        <a
          class="download-success-view__architecture-button"
          :href="arm64Url"
          referrerpolicy="unsafe-url"
          @click="onClickAction('arm64')"
        >
          <AppleMXIcon />
          <span>{{ $t('appleDownloadView.downloadARM') }}</span>
        </a>
        <div class="download-success-view__architecture-bg" />
      </button>
      <button
        class="download-success-view__architecture-card"
      >
        <a
          class="download-success-view__architecture-button"
          :href="intelUrl"
          referrerpolicy="unsafe-url"
          @click="onClickAction('intel')"
        >
          <AppleIntelIcon />
          <span>{{ $t('appleDownloadView.downloadIntel') }}</span>
        </a>
        <div class="download-success-view__architecture-bg" />
      </button>
    </div>
    <p class="download-success-view__help-center">
      {{ $t('appleDownloadView.helpCenterPhrase') }}
      <a href="https://voicemodmac.zendesk.com/hc/en-us/articles/9327214806546">
        {{ $t('appleDownloadView.helpCenterLink') }}
      </a>
    </p>
    <p class="download-success-view__windows-download-link">
      <i18n
        path="loginAccountSuccess.windows-download"
      >
        <a
          place="download_link"
          class="simple-link"
          data-testid="windows-download-link"
          @click.prevent="downloadWindows"
        >
          {{ $t('loginAccountSuccess.here') }}
        </a>
      </i18n>
    </p>
  </div>
</template>

<script>
import AppleMXIcon from '@/components/AppleMXIcon/AppleMXIcon.vue';
import AppleIntelIcon from '@/components/AppleIntelIcon/AppleIntelIcon.vue';


export default {
    components: {
        AppleMXIcon,
        AppleIntelIcon,
    },
    props: {
        arm64Url: {
            type: String,
            default: null,
        },
        intelUrl: {
            type: String,
            default: null,
        },
        action: {
            type: String,
            default: '',
        },
    },
    methods: {
        downloadWindows() {
            this.$emit('crossOsDownload', 'Windows');
        },
        onClickAction(button) {
            this.$emit('downloadLinkClicked', 'auto', button);
        },
    },
};
</script>

<style src="./DownloadFlagshipComponent.scss" lang="scss"></style>
